// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3rMpZ","file":"styles_file__1Xwde"};